
import organicTabs from '../vendors/organic-tab';
import slick from '../vendors/slick.min';
import Owl from '../vendors/owl.carousel.min';
import Masonry from '../vendors/masonry.min';
import GSAP from '../vendors/gsap.min';
import ScrollTrigger from '../vendors/ScrollTrigger.min';
import SplitText from '../vendors/SplitText.min';


if (jQuery(window).width() > 1003) {
	jQuery(document).on('scroll', function () {
		if (jQuery(document).scrollTop() > 100) {
			jQuery('header, body').addClass('shrink');
		} else {
			jQuery('header, body').removeClass('shrink');
		}
	});
}
if (jQuery(window).width() < 1003) {
	jQuery(document).on('scroll', function () {
		if (jQuery(document).scrollTop() > 30) {
			jQuery('header, body').addClass('shrink');
		} else {
			jQuery('header, body').removeClass('shrink');
		}
	});
}


// script for header up and down
if (jQuery(window).width() > 1003) {
	let lastScrollTop = 0,
		delta = 15;
	jQuery(window).scroll(function (event) {
		const st = jQuery(this).scrollTop();
		if (Math.abs(lastScrollTop - st) <= delta) {
			return;
		}
		if (st > lastScrollTop && lastScrollTop > 0) {
			jQuery('.header-section-inner').addClass('nav-up');
			jQuery('.header-section-inner').removeClass('nav-down');
			jQuery('.header-section-inner').removeClass('stay-show-header');
		} else {
			jQuery('.header-section-inner').removeClass('nav-up');
			jQuery('.header-section-inner').addClass('nav-down');
		}
		lastScrollTop = st;
	});
}


jQuery(function () {

	function isWindows() {
		return navigator.platform.toUpperCase().indexOf('WIN') > -1;
	}

	// Check if the operating system is Windows and add the class if true
	if (isWindows()) {
		jQuery('body').addClass('style-for-window');
	}
	// Function to detect if the operating system is macOS
	function isMacOS() {
		return navigator.platform.toUpperCase().indexOf('MAC') > -1;
	}

	// Check if the operating system is macOS and add the class if true
	if (isMacOS()) {
		jQuery('body').addClass('style-for-mac');
	}

	gsap.registerPlugin(SplitText, ScrollTrigger);

	let animationTriggered = false;

	// Perfect Wp-images

	const extLink = jQuery('body a').filter(function () {
		return this.hostname && this.hostname !== location.hostname;
	});
	extLink.each(function () {
		jQuery(this).attr('target', '_blank');
		jQuery(this).addClass('external-link');
	});


	/**
	 * Toggle menu for mobile
	 */
	// accessible sub menu
	jQuery('.menu-item-has-children > a')
		.focus(function () {
			jQuery(this).siblings('.sub-menu').addClass('focused');
		})
		.blur(function () {
			jQuery(this).siblings('.sub-menu').removeClass('focused');
		});

	jQuery('.menu-btn').on('click', function () {
		jQuery(this).toggleClass('active');
		jQuery('.nav-overlay').toggleClass('open');
		jQuery('html, body').toggleClass('no-overflow');
		jQuery('.header-nav ul li.active').removeClass('active');
		jQuery('.header-nav ul.sub-menu').slideUp();
	});
	jQuery.noConflict();

});

